import { BrowserRouter, Navigate, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useUTMCapture } from "./hooks/useUTM";
import GlobalRocketEasterEgg from "./components/feature/GlobalRocketEasterEgg";

/** Detects UTM params in the URL and stores them in sessionStorage. Must live inside BrowserRouter. */
function UTMCapture() {
  useUTMCapture();
  return null;
}

function ComingSoonGate() {
  const location = useLocation();

  if (location.pathname !== "/uz-coskoro") {
    return <Navigate to="/uz-coskoro" replace />;
  }

  return <AppRoutes />;
}

function App() {
  const siteMode = import.meta.env.VITE_SITE_MODE?.trim().toLowerCase();

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <UTMCapture />
        {siteMode === "coming-soon" ? <ComingSoonGate /> : <AppRoutes />}
        <GlobalRocketEasterEgg />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
